import * as _device from './device';
export { _device as device };
export { declension } from './declension';
export { default as numberFormat } from './number-format';
